import { API_BASE_URL } from '../services/api/client';

/**
 * Resolve media URLs for API-served assets: uploads, relative paths meant for the backend, full presigned URLs.
 * Catalog model/provider icons use `resolveModelIconUrl` instead.
 */
export function mediaUrl(path) {
  if (!path) return undefined;
  const s = String(path).trim();

  if (s.startsWith('data:')) return s;

  if (s.startsWith('http://') || s.startsWith('https://')) {
    return s;
  }

  if (s.startsWith('//')) {
    if (typeof window !== 'undefined') {
      return `${window.location.protocol}${s}`;
    }
    return `https:${s}`;
  }

  const base =
    API_BASE_URL === '/api'
      ? typeof window !== 'undefined'
        ? window.location.origin
        : ''
      : API_BASE_URL;
  if (!base) return s.startsWith('/') ? s : `/${s}`;
  return `${base}${s.startsWith('/') ? '' : '/'}${s}`;
}
